import { AppState } from '../../rootReducer';

import { AuthState } from '../types';

export const getState = (state: AppState): AuthState => state.authReducer;

export const getUserId = (state: AppState): string => state.authReducer.currentUser?.uid || '';

export const getUserFullName = (state: AppState): string =>
    `${state.authReducer.currentUser?.firstName} ${state.authReducer.currentUser?.lastName}` || '';

export const getUserEmail = (state: AppState): string => state.authReducer.currentUser?.email || '';

export const getUserRoles = (state: AppState): string[] => state.authReducer.currentUser?.roles || [];

export const getUserContactTypes = (state: AppState): string[] => state.authReducer.currentUser?.contactTypes || [];

export const isLogged = (state: AppState): boolean => state.authReducer.isLogged;

export const isLoading = (state: AppState): boolean => state.authReducer.isLoading;

export const getError = (state: AppState): string | undefined => state.authReducer.error;

export const getResetPasswordError = (state: AppState): string | undefined => state.authReducer.restartError;

export const getResetSent = (state: AppState): boolean | undefined => state.authReducer.restartSent;
